import {observer} from "mobx-react";
import {EditorContainer, SavingOverlay} from "./RetryComponent.styled";
import CircularProgress from "@mui/material/CircularProgress";
import TemplateEditor from "../../../../../../../elements/v2/TemplateEditor/TemplateEditor";
import React, {useEffect} from "react";
import {useStore} from "../../../../../../../hooks";

const RetryEditor = observer(({ index }) => {
  const { marketingStore } = useStore();
  const { retryStore } = marketingStore;
  const retry = retryStore.getOne({ index });

  useEffect(() => {
    if (retry.isExpanded) {
      const saveData = setInterval(() => {
        retryStore.saveEditorData({ currentRetry: retry });
      }, 5000);

      return () => clearTimeout(saveData);
    }
  }, [retry.isExpanded]);
  
  return (
    <>
      {retry.isExpanded && (
        <EditorContainer>
          {retry.isSavingContent}
          <SavingOverlay isSaving={retry.isSavingContent}>
            <CircularProgress size={16} />
            <span>Saving...</span>
          </SavingOverlay>
          <TemplateEditor
            store={retry.templateEditorStore}
            isPopup={false}
            key={`editor-retry-${index}`}
          />
        </EditorContainer>
      )}
    </>
  );
});

export default RetryEditor;
